var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.9 168.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: -179.93,
    cy: 478.54,
    fx: -179.93,
    fy: 478.54,
    r: 18.6,
    gradientTransform: "translate(251.43 561.71) rotate(1.4) scale(1 -1.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -184.1,
    cy: 462.5,
    fx: -184.1,
    fy: 462.5,
    r: 1.6,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -181.6,
    cy: 464.3,
    fx: -181.6,
    fy: 464.3,
    r: 1.3,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -181.9,
    cy: 469.3,
    fx: -181.9,
    fy: 469.3,
    r: 1.3,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -178.9,
    cy: 464.7,
    fx: -178.9,
    fy: 464.7,
    r: 1.4,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -176.1,
    cy: 464.8,
    fx: -176.1,
    fy: 464.8,
    r: 2.1,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: -173.4,
    cy: 464.2,
    fx: -173.4,
    fy: 464.2,
    r: 1.6,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 1633.22,
    cy: 2850.35,
    fx: 1633.22,
    fy: 2850.35,
    r: 18.6,
    gradientTransform: "translate(1864.26 -2905.25) rotate(-178.4) scale(1 -1.1) skewX(-.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 111.31,
    cy: 59.7,
    fx: 111.31,
    fy: 59.7,
    r: 1.7,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 108.61,
    cy: 57.96,
    fx: 108.61,
    fy: 57.96,
    r: 1.41,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 105.91,
    cy: 57.59,
    fx: 105.91,
    fy: 57.59,
    r: 1.44,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 103.1,
    cy: 57.6,
    fx: 103.1,
    fy: 57.6,
    r: 2.26,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 100.21,
    cy: 58.3,
    fx: 100.21,
    fy: 58.3,
    r: 1.71,
    gradientTransform: "translate(0 176.8) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf0010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fd1517"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: -175.16,
    cy: 436,
    fx: -175.16,
    fy: 436,
    r: 37,
    gradientTransform: "translate(219.22 568.95) rotate(2.7) scale(1 -1.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ef7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017733"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: -106.17,
    cy: 419.7,
    fx: -106.17,
    fy: 419.7,
    r: 31.7,
    gradientTransform: "translate(205.51 542.85) rotate(2.6) scale(1 -1.1) skewX(-.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fd1517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf0010"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "110.5 146.7 110.1 146.8 110.1 146.8 110.5 146.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.7 147.5 109.5 146.4 110.4 146.2 110.5 146.7 110.6 146.7 110.5 146.7 110.6 147.2 109.7 147.5",
    style: {
      fill: "#e92027"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.2,144.9h-.2l-1.6,.5h0l1.6-.4h.2v-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.1 146.1 107.8 145.5 107.7 145 110.1 144.4 110.4 145.4 108.1 146.1",
    style: {
      fill: "#e92027"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.1,37.2l-15.7-20.4c-.4-.6-1.3-.6-1.6,0l-13.6,21.9c-.4,.8,.4,1.7,1.2,1.3l6.6-1.5,1.1,23c0,.4,.3,.7,.7,.7h0c.4,0,.7-.4,.7-.8v-1.7c-.1-.4,.1-.7,.5-.8,.4,0,.8,.2,.8,.7v1.7c.1,.4,.4,.7,.8,.7h0c.4,0,.7-.4,.7-.8v-2.3c-.1-.4,.1-.7,.5-.8,.4,0,.8,.2,.8,.7v2.3c.1,.4,.5,.7,.8,.7h0c.4,0,.7-.4,.7-.8l-.2-3.9c0-.4,.2-.7,.6-.8,.4,0,.8,.2,.8,.7l.2,3.9c0,.4,.3,.7,.7,.7h0c.4,0,.7-.4,.7-.8v-.2c0-.4,.2-.7,.6-.8,.4,0,.8,.2,.8,.7v.2c0,.4,.4,.7,.7,.7h0c.4,0,.7-.4,.7-.8v-1.9c-.1-.4,.1-.7,.5-.8,.4,0,.8,.2,.8,.7v1.9c.1,.4,.4,.7,.8,.7h0c.4,0,.7-.4,.7-.8l-1.1-22.7,6.7,.7c.8,.2,1.5-.7,1.1-1.5l-.1,.3Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9,65.1c-1.8,0-3.4-1.5-3.5-3.4l-1-19.6-3.2,.7c-1.3,.5-2.8,.1-3.8-1-1.1-1.2-1.3-2.9-.6-4.4v-.2c.1,0,13.7-21.8,13.7-21.8,.6-1.1,1.7-1.8,3-1.9,1.3,0,2.4,.5,3.2,1.6l15.8,20.6c.8,1.3,.8,3-.1,4.3-.9,1.2-2.3,1.8-3.7,1.5l-3.4-.3,1,19.4c0,1-.3,1.9-.9,2.6s-1.5,1.1-2.4,1.2c-.5,0-1,0-1.4-.2-.4,.2-.9,.4-1.4,.4s-1,0-1.4-.2c-.4,.2-.9,.4-1.4,.4s-1,0-1.4-.2c-.4,.2-.9,.4-1.4,.4s-1,0-1.4-.2c-.4,.2-.9,.4-1.4,.4s-1,0-1.4-.2c-.4,.2-.9,.4-1.4,.4h-.1v-.3Zm.7-3.6h0Zm12.4-.7h0Zm-4.4-3.6h0Zm-2-3.5c.8,0,1.5,.3,2.2,.8,.6,.5,1,1.1,1.2,1.9,.4-.4,1-.8,1.6-.9l-1-20.6,5.8,.6-11.5-14.9-9.8,15.9,5.6-1.3,1.1,21.1h.2c.4-.4,1-.6,1.5-.7h.4c.5-.8,1.3-1.5,2.3-1.7h.6l-.2-.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.7,57.5c0,.4-.3,.7-.7,.8-.4,0-.7-.3-.7-.7l-.2-3.1c0-.4,.3-.7,.7-.8s.7,.3,.7,.7c0,0,.2,3.1,.2,3.1Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1,61.1c-.9,0-1.7-.3-2.3-.9-.7-.6-1.1-1.5-1.1-2.5l-.2-3.1c-.1-2,1.3-3.6,3.2-3.8,.9,0,1.8,.3,2.5,.9,.7,.6,1.1,1.5,1.1,2.5l.2,3.1c0,2-1.4,3.6-3.2,3.8h-.2Zm-1.5-5c.4,.3,.9,.5,1.4,.5s1-.3,1.4-.7c-.4-.3-.9-.6-1.4-.5-.5,0-1,.3-1.4,.7Zm-.7-1.5h0Zm4-.2h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.4,55.3c0,.4-.3,.7-.7,.8s-.7-.3-.7-.7v-2.2c-.1-.4,.2-.7,.5-.8,.4,0,.7,.3,.7,.7v2.2h.2Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8,58.9c-1.8,0-3.4-1.5-3.4-3.4v-2.2c-.2-2,1.2-3.6,3.1-3.8,1.9,0,3.5,1.4,3.6,3.4v2.2c.2,1-.2,1.9-.8,2.6-.6,.7-1.5,1.1-2.4,1.2h-.1Zm-2.1-3.5h0Zm.2-1.1c.4,.6,1,.9,1.8,.9,.7,0,1.3-.5,1.7-1.1-.4-.6-1-.9-1.8-.9-.5,0-1,.3-1.4,.7-.1,.1-.2,.3-.3,.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.2,49.9c0,.4-.3,.7-.7,.8s-.7-.3-.7-.7v-2.2c-.1-.4,.2-.7,.6-.8s.7,.3,.7,.7v2.2h.1Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,53.5c-.9,0-1.7-.3-2.3-.9-.7-.6-1.1-1.5-1.1-2.5v-2.2c-.2-2,1.2-3.6,3.1-3.8,1.8-.1,3.5,1.4,3.6,3.4v2.2c.2,2-1.2,3.7-3.1,3.8h-.2Zm-1.8-4.5c.4,.6,1,1,1.8,.9,.7,0,1.4-.5,1.7-1.1,0-.1-.2-.3-.3-.4-.4-.4-.9-.6-1.5-.5-.5,0-1,.3-1.4,.7-.1,.1-.2,.3-.3,.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.2,54.9c0,.4-.3,.7-.7,.8-.4,0-.7-.3-.7-.7v-2.3c-.1-.4,.2-.7,.5-.8,.4,0,.7,.3,.7,.7v2.3h.2Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,58.5c-.9,0-1.7-.3-2.3-.9-.7-.6-1.1-1.5-1.1-2.5v-2.3c-.2-1,.1-1.9,.8-2.6,.6-.7,1.5-1.1,2.4-1.2,1.9-.1,3.5,1.4,3.6,3.4v2.3c.2,1-.1,1.9-.8,2.6-.6,.7-1.5,1.1-2.4,1.2h-.2Zm-1.8-4.6c.4,.6,1,.9,1.7,.9,.5,0,1-.3,1.4-.7,0-.1,.2-.2,.2-.4,0-.1-.2-.2-.3-.3-.4-.4-.9-.6-1.5-.5-.5,0-1,.3-1.4,.7,0,.1-.2,.2-.2,.4l.1-.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.1,56.1c0,.4-.3,.7-.7,.8s-.7-.3-.7-.7l-.2-4.7c0-.4,.3-.7,.7-.8,.4,0,.7,.3,.7,.7,0,0,.2,4.7,.2,4.7Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,59.8c-.9,0-1.7-.3-2.3-.9-.7-.6-1.1-1.5-1.1-2.5l-.2-4.7c0-1,.3-1.9,.9-2.6,.6-.7,1.5-1.1,2.4-1.2,2-.1,3.5,1.4,3.6,3.4l.2,4.7c0,1-.3,1.9-.9,2.6s-1.5,1.1-2.4,1.2h-.2Zm-2.1-3.5h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.8,56c0,.4-.3,.7-.7,.8s-.7-.3-.7-.7l-.2-3.1c0-.4,.3-.7,.7-.8s.7,.3,.7,.7c0,0,.2,3.1,.2,3.1Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,59.6c-.9,0-1.7-.3-2.3-.9-.7-.6-1.1-1.5-1.1-2.5l-.2-3c0-2,1.4-3.7,3.2-3.8,.9,0,1.8,.3,2.5,.9,.7,.6,1.1,1.5,1.1,2.5l.2,3c0,1-.3,1.9-.9,2.6s-1.5,1.1-2.4,1.2h-.1Zm-2.1-3.5h0Zm4.1-.2h0Zm-3.5-1.3c.4,.3,.9,.5,1.4,.5s1-.3,1.4-.7c-.4-.3-.9-.5-1.4-.5s-1,.3-1.4,.7Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.1,135.9l15.5,20.8c.4,.6,1.3,.6,1.6,0l13.8-22c.4-.8-.4-1.7-1.2-1.3l-6.6,1.5-1-23.2c0-.4-.3-.7-.7-.7h0c-.4,0-.7,.4-.7,.8v1.7c0,.4-.2,.7-.5,.8-.4,0-.8-.3-.8-.7v-1.8c0-.4-.4-.7-.8-.7h0c-.4,0-.7,.4-.7,.8v2.3c.1,.4-.1,.7-.5,.8-.4,0-.8-.3-.8-.7v-2.4c-.1-.4-.4-.7-.8-.7h0c-.4,0-.7,.4-.7,.8l.2,3.9c0,.4-.2,.7-.6,.8-.4,0-.8-.3-.8-.7l-.2-3.9c0-.4-.3-.7-.7-.7h0c-.4,0-.7,.4-.7,.8v.2c0,.4-.2,.7-.6,.8-.4,0-.8-.3-.8-.7v-.2c0-.4-.4-.7-.7-.7h0c-.4,0-.7,.4-.7,.8v1.9c0,.4-.1,.7-.5,.8-.4,0-.8-.3-.8-.7v-2c0-.4-.4-.7-.8-.7h0c-.4,0-.7,.4-.7,.8l.9,23-6.7-.8c-.8-.3-1.5,.7-1.1,1.5l.2-.3Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,160c-1.2,0-2.4-.6-3.1-1.6l-15.6-21c-.8-1.4-.8-3.1,.2-4.4,.9-1.2,2.3-1.7,3.7-1.4l3.4,.4-.8-19.7c0-2,1.4-3.6,3.3-3.7,.5,0,1,0,1.4,.2,.4-.2,.9-.4,1.4-.4s1,0,1.4,.2c.4-.2,.9-.4,1.4-.4s1,0,1.4,.2c.4-.2,.9-.4,1.4-.4s1,0,1.4,.2c.4-.2,.9-.4,1.4-.4s1,0,1.4,.2c.4-.2,.9-.4,1.4-.4h0c1.9,0,3.4,1.5,3.5,3.4l.8,19.9,3.2-.7c1.3-.5,2.8,0,3.8,1,1.1,1.2,1.3,2.9,.6,4.4v.2c-.1,0-13.8,21.9-13.8,21.9-.6,1.1-1.8,1.8-3,1.9h0l-.2,.4Zm-11.6-22.3l11.4,15.3,10-16-5.7,1.3-.9-21.3h-.2c-.4,.4-1,.6-1.5,.7h-.4c-.5,.8-1.3,1.5-2.3,1.6-1,.2-2,0-2.7-.7-.6-.5-1-1.2-1.2-1.9-.4,.4-1,.7-1.6,.9l.9,20.8s-5.8-.7-5.8-.7Zm.7-25.5h0Zm2.8-.1h0Zm1.3,0h0Zm1.5-.1h0Zm1.2-.1h0Zm8.4-.4h0Zm2.8-.1h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.6,115.6c0-.4,.3-.7,.7-.8,.4,0,.7,.3,.7,.7v3.1c.1,.4-.2,.7-.5,.8-.4,0-.7-.3-.7-.7v-3.1h-.2Z",
    style: {
      fill: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,122.2c-.9,0-1.8-.3-2.4-.9-.7-.6-1.1-1.5-1.1-2.5v-3.1c-.2-1,.2-1.9,.8-2.6,.6-.7,1.5-1.1,2.4-1.2,.9,0,1.8,.3,2.5,.9s1.1,1.5,1.1,2.5v3.1c.2,2-1.3,3.6-3.1,3.7h0l-.2,.1Zm-2.2-3.5h0Zm4.1-.2h0Zm-3.5-1.4c.4,.3,.9,.5,1.4,.5s1-.2,1.3-.6c-.4-.3-.9-.5-1.4-.5s-1,.3-1.4,.6h.1Zm-.7-1.5h0Zm4.1-.2h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M107.9,117.8c0-.4,.3-.7,.7-.8s.7,.3,.7,.7v2.2c.1,.4-.2,.7-.6,.8-.4,0-.7-.3-.7-.7v-2.2h-.1Z",
    style: {
      fill: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,123.6c-.9,0-1.7-.3-2.4-.9-.7-.6-1.1-1.5-1.1-2.5v-2.3c-.2-2,1.3-3.6,3.2-3.7h0c1.9,0,3.4,1.5,3.5,3.4v2.2c.2,2-1.3,3.6-3.2,3.7h0v.1Zm-1.8-4.6c.4,.6,1.1,1,1.7,.9,.7,0,1.3-.5,1.7-1.1,0-.1-.2-.2-.3-.3-.4-.4-1-.6-1.5-.6-.7,0-1.3,.5-1.7,1.1h.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.2,118.1c0-.4,.3-.7,.7-.8,.4,0,.7,.3,.7,.7v2.3c.1,.4-.2,.7-.6,.8s-.7-.3-.7-.7v-2.3h-.1Z",
    style: {
      fill: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,124c-1.9,0-3.4-1.5-3.5-3.4v-2.3c-.2-2,1.3-3.6,3.2-3.7h0c.9,0,1.8,.3,2.4,.9,.7,.6,1.1,1.5,1.1,2.5v2.3c.2,2-1.3,3.6-3.2,3.7h0Zm-2.1-3.5h0Zm.3-1.2c0,.1,.2,.2,.3,.3,.4,.4,.9,.6,1.5,.6,.7,0,1.3-.4,1.7-1-.4-.5-1-.9-1.7-.9s-1.3,.4-1.7,1h-.1Zm-.4-1.1h0Zm0,0l4.1-.2h0l-4.1,.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.3,116.9c0-.4,.3-.7,.7-.8,.4,0,.7,.3,.7,.7l.2,4.7c0,.4-.3,.7-.7,.8-.4,0-.7-.3-.7-.7l-.2-4.7Z",
    style: {
      fill: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.3,125.1c-.9,0-1.7-.3-2.4-.9-.7-.6-1.1-1.5-1.1-2.5l-.2-4.7c0-2,1.4-3.6,3.3-3.7,1,0,1.8,.3,2.5,.9s1.1,1.5,1.1,2.5l.2,4.7c0,2-1.4,3.6-3.3,3.7h-.1Zm-2.1-3.5h0Zm4-.2h0Zm-4.2-4.5h0Zm4-.2h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.5,117c0-.4,.3-.7,.7-.8s.7,.3,.7,.7v3.1c.1,.4-.2,.7-.5,.8s-.7-.3-.7-.7v-3.1h-.2Z",
    style: {
      fill: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.4,123.6c-1.9,0-3.4-1.5-3.5-3.4v-3.1c-.2-2,1.3-3.6,3.1-3.7h0c1.9,0,3.4,1.5,3.5,3.4v3.1c.2,2-1.3,3.6-3.1,3.7h0Zm-1.5-5c.4,.3,.9,.5,1.4,.5s1-.3,1.4-.6c-.4-.3-.9-.5-1.4-.5s-1,.3-1.4,.6Zm3.3-1.7h0Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "50.9 129.5 49.4 98.7 74.7 92.9 76.2 123.7 91.4 120.2 87.8 44.1 72.6 47.6 74 77.2 48.7 83.1 47.3 53.4 32.1 56.9 35.7 133 50.9 129.5",
    style: {
      fill: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,136.5l-3.8-81.9,20.6-4.7,1.4,29.7,19.9-4.6-1.4-29.7,20.6-4.7,3.8,81.9-20.6,4.7-1.5-30.8-19.9,4.6,1.5,30.8-20.6,4.7h0Zm1.8-77.4l3.3,70.4,9.8-2.3-1.5-30.8,30.7-7.1,1.5,30.8,9.8-2.3-3.3-70.4-9.8,2.3,1.4,29.7-30.7,7.1-1.4-29.7s-9.8,2.3-9.8,2.3Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "115.3 101.3 112.4 41.9 94.7 46 98.5 123.6 139.2 114.2 138.2 96 115.3 101.3",
    style: {
      fill: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,127.1l-4.1-83.3,23.1-5.3,2.9,59.3,22.9-5.3,1.2,24-46,10.6h0Zm1.6-78.8l3.5,71.8,35.2-8.2-.6-12.5-22.9,5.3-2.9-59.3-12.3,2.8v.1Z",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d218abe3e82ea1e32ff4a4ea4f3359e.svg";
export { ForwardRef as ReactComponent };